export default "__VITE_ASSET__Co6FUeNx__"